var map = {
	"./001-medal-47.svg": 59618,
	"./012-trophy-18.svg": 74588,
	"./021-medal-37.svg": 63530,
	"./022-medal-36.svg": 61633,
	"./023-crown-1.svg": 87824,
	"./024-shield-6.svg": 68267,
	"./027-diploma.svg": 33217,
	"./029-trophy-15.svg": 61158,
	"./031-trophy-14.svg": 4353,
	"./032-crown.svg": 19791,
	"./033-gold-medal.svg": 66109,
	"./034-trophy-13.svg": 31543,
	"./036-file.svg": 50085,
	"./039-trophy-12.svg": 34718,
	"./040-medal-33.svg": 22817,
	"./041-medal-32.svg": 81470,
	"./042-medal-31.svg": 7761,
	"./043-podium-1.svg": 95127,
	"./044-trophy-11.svg": 33000,
	"./046-flags.svg": 54525,
	"./047-winner.svg": 30419,
	"./048-trophy-10.svg": 34782,
	"./053-shield-1.svg": 78100,
	"./054-shield.svg": 32289,
	"./056-medal-28.svg": 62848,
	"./058-trophy-9.svg": 10306,
	"./060-trophy-8.svg": 4005,
	"./061-silver-medal.svg": 85425,
	"./062-trophy-7.svg": 79690,
	"./063-medal-25.svg": 81002,
	"./065-trophy-6.svg": 26581,
	"./066-medal-23.svg": 86095,
	"./067-medal-22.svg": 47962,
	"./069-medal-20.svg": 23726,
	"./072-badge-2.svg": 87171,
	"./073-trophy-5.svg": 50233,
	"./075-flag.svg": 68524,
	"./077-trophy-4.svg": 40678,
	"./080-medal-14.svg": 98927,
	"./082-badge-1.svg": 57389,
	"./083-trophy-3.svg": 5384,
	"./085-trophy-1.svg": 82556,
	"./086-medal-12.svg": 75970,
	"./088-medal-11.svg": 17628,
	"./089-medal-10.svg": 83119,
	"./093-medal-6.svg": 62505,
	"./094-medal-5.svg": 21932,
	"./095-medal-4.svg": 91155,
	"./097-medal-3.svg": 92182,
	"./099-medal-1.svg": 91411,
	"./belt-black.svg": 30674,
	"./belt.svg": 78940,
	"./biceps-dumbbell.svg": 84515,
	"./darts.svg": 57515,
	"./guru-1.svg": 6190,
	"./guru.svg": 24123,
	"./heart.svg": 92599,
	"./mandala.svg": 28732,
	"./rocket.svg": 5407,
	"./shield-1.svg": 15177,
	"./shield.svg": 66332,
	"./weight.svg": 8044,
	"./yin-yang.svg": 40858,
	"./yukata.svg": 16074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59516;